// Web-Push-Helfer: Service Worker registrieren, Berechtigung holen,
// Subscription beim Backend hinterlegen.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  return pushSupported() ? Notification.permission : "unsupported";
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

/** Aktiviert Push für dieses Gerät. Gibt true bei Erfolg zurück. */
export async function enablePush() {
  if (!pushSupported()) throw new Error("Dieser Browser unterstützt keine Push-Benachrichtigungen.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Benachrichtigungen wurden nicht erlaubt.");

  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await axios.get(`${API}/push/vapid-public-key`);
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.key),
    });
  }
  await axios.post(`${API}/push/subscribe`, sub.toJSON());
  return true;
}

/** Prüft, ob dieses Gerät bereits eine aktive Subscription hat. */
export async function hasPushSubscription() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/sw.js");
    if (!reg) return false;
    return Boolean(await reg.pushManager.getSubscription());
  } catch {
    return false;
  }
}
